window.addEventListener("load", function () {
  let selector = ".footer__top-button";
  let scrollTopButton = document.querySelector(selector);

  if (!scrollTopButton) {
    return;
  }

  // add click event
  scrollTopButton.addEventListener("click", function () {
    window.scrollTo({top: 0, behavior: "smooth"});
  });

  // on scroll
  window.addEventListener("scroll", function () {
    let body = document.body, html = document.documentElement;
    let pageHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);

    if ((pageHeight > window.innerHeight * 2) && (window.scrollY > window.innerHeight * 2)) {
      scrollTopButton.classList.add("active");
    } else {
      scrollTopButton.classList.remove("active");
    }
  });
});
